import React, { useState, useEffect } from 'react';
import { Twitter, Menu, X } from 'lucide-react';
import { toast } from 'sonner';

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [menuOpen]);

  const scrollToSection = (sectionId) => {
    setMenuOpen(false);
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleLaunch = (e) => {
    e.preventDefault();
    setMenuOpen(false);
    toast('Coming soon', {
      description: 'The full app is launching soon. Explore the live demo in the Solution section.',
    });
    document.getElementById('solution')?.scrollIntoView({ behavior: 'smooth' });
  };

  const navItems = [
    { label: 'Token', id: 'token' },
    { label: 'Problem', id: 'problem' },
    { label: 'Solution', id: 'solution' },
    { label: 'Build', id: 'build' },
  ];

  return (
    <header className={`site-header ${scrolled ? 'scrolled' : ''}`} data-testid="site-header">
      {/* Logo */}
      <div className="header-logo">
        <img src="/logo.png" alt="Zyber" className="logo-img" data-testid="header-logo" />
        <span className="logo-wordmark">Zyber</span>
      </div>

      {/* Center Nav (desktop) */}
      <nav className="header-nav" data-testid="nav-box">
        {navItems.map((item, i) => (
          <React.Fragment key={item.id}>
            <button onClick={() => scrollToSection(item.id)} className="nav-link">
              {item.label}
            </button>
            {i < navItems.length - 1 && <span className="nav-dot">•</span>}
          </React.Fragment>
        ))}
        <span className="nav-dot">•</span>
        <a href="https://docs.zybersec.pro" target="_blank" rel="noopener noreferrer" className="nav-link">Docs</a>
      </nav>

      {/* Right CTA (desktop) */}
      <div className="header-right">
        <a href="https://x.com/zybersecai" target="_blank" rel="noopener noreferrer" className="social-icon" data-testid="nav-twitter">
          <Twitter size={18} />
        </a>
        <a href="#" onClick={handleLaunch} className="cta-button" data-testid="nav-launch">
          Launch App
        </a>
      </div>

      {/* Mobile hamburger toggle */}
      <button
        className="mobile-menu-toggle"
        onClick={() => setMenuOpen((v) => !v)}
        aria-label="Toggle menu"
        data-testid="mobile-menu-toggle"
      >
        {menuOpen ? <X size={22} /> : <Menu size={22} />}
      </button>

      {/* Mobile menu overlay */}
      <div className={`mobile-menu ${menuOpen ? 'open' : ''}`} data-testid="mobile-menu">
        <nav className="mobile-menu-nav">
          {navItems.map((item) => (
            <button
              key={item.id}
              onClick={() => scrollToSection(item.id)}
              className="mobile-nav-link"
              data-testid={`mobile-nav-${item.id}`}
            >
              {item.label}
            </button>
          ))}
          <a href="https://docs.zybersec.pro" target="_blank" rel="noopener noreferrer" className="mobile-nav-link" onClick={() => setMenuOpen(false)}>Docs</a>
        </nav>

        <a href="#" onClick={handleLaunch} className="cta-button mobile-cta" data-testid="mobile-nav-launch">
          Launch App
        </a>

        <div className="mobile-menu-socials">
          <a href="https://x.com/zybersecai" target="_blank" rel="noopener noreferrer" className="social-icon">
            <Twitter size={20} />
          </a>
        </div>
      </div>
    </header>
  );
};

export default Header;
